import { SplitDirection } from "@/store/modes/alignment-ui-types";
import {
  selectAlignedSheetForSheetToSheetAlignment,
  selectReferenceForSheetToSheetAlignment,
  selectSplitDirectionForSheetToSheetAlignment,
} from "@/store/modes/sheet-to-sheet-alignment-mode-selectors";
import { setSheetToSheetAlignmentSplitDirection } from "@/store/modes/sheet-to-sheet-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { selectIElement } from "@faro-lotv/project-source";
import { useCallback, type JSX } from "react";
import { AlignmentModeSplitScreenOverlay } from "../alignment-modes-commons/alignment-mode-split-screen-overlay";

/** @returns The sheet to sheet alignment split screen */
export function SheetToSheetAlignmentSplitScreen(): JSX.Element {
  const dispatch = useAppDispatch();
  const splitDirection = useAppSelector(
    selectSplitDirectionForSheetToSheetAlignment,
  );

  // callback function for changing split-screen direction
  const changeSplitDirection = useCallback(() => {
    const newDirection =
      splitDirection === SplitDirection.horizontalSplit
        ? SplitDirection.verticalSplit
        : SplitDirection.horizontalSplit;
    dispatch(setSheetToSheetAlignmentSplitDirection(newDirection));
  }, [dispatch, splitDirection]);

  const alignedSheetId = useAppSelector(
    selectAlignedSheetForSheetToSheetAlignment,
  );
  const alignedSheet = useAppSelector(selectIElement(alignedSheetId));

  const refSheetId = useAppSelector(selectReferenceForSheetToSheetAlignment);
  const refSheet = useAppSelector(selectIElement(refSheetId));

  return (
    <AlignmentModeSplitScreenOverlay
      splitDirection={splitDirection}
      onChangeSplitDirection={changeSplitDirection}
      alignedElement={alignedSheet}
      referenceElement={refSheet}
    />
  );
}
